__turbopack_context__.v({
  "VideoPlayers": "video-module__LTLp1a__VideoPlayers",
});
